import gql from 'graphql-tag';
import _, { get } from 'lodash';
import { compose, graphql } from 'react-apollo';
import { parse } from 'src/_shared/services/utils.js';
import {
	GetCompanySettingsData,
	updateCompany,
} from '../../graphql/custom/company';

export const withGetCompanyData = (Component, variables) => {
	return compose(
		graphql(GetCompanySettingsData, {
			options: (props) => ({
				variables,
				fetchPolicy: 'cache-first',
				skip: !props.companyId || props.companyId === 'skip',
			}),
			props(props) {
				const companyData = get(props, 'data.getCompanyData', undefined);
				const newCompanyData = {...companyData};
				if (companyData) {
					let questions = get(newCompanyData, 'referralQuestions', []);
					questions = _.sortBy(questions, ['sortOrder']);
					questions = questions.map((question) => {
						const newQuestion = {...question};
						newQuestion.questions = parse(question.questions);
						return newQuestion;
					});
					if (questions) newCompanyData.referralQuestions = questions;
				}

				return {
					companyData: newCompanyData,
				};
			},
		}),
		graphql(gql(updateCompany), {
			props: (props) => ({
				onUpdateCompany(input) {
					const optimisticResponseData = {
						...props.ownProps.company,
						...input.input,
					};
					props.mutate({
						variables: input,
						optimisticResponse: {
							__typeName: 'Mutation',
							updateCompany: {
								...optimisticResponseData,
								__typeName: 'updateCompany',
								logo: { ...input.input.logo, __typename: 'S3Object' },
							},
						},
						update(proxy) {
							const data = proxy.readQuery({
								query: GetCompanySettingsData,
								variables: { companyId: props.ownProps.currentUser.companyId },
							});
							proxy.writeQuery({
								query: GetCompanySettingsData,
								data,
								variables: { companyId: props.ownProps.currentUser.companyId },
							});
						},
					});
				},
			}),
		})
	)(Component);
};

